/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OpenInvitationConfigCto } from '../../models/open-invitation-config-cto';

export interface GetByIdAsync$Plain$Params {
  companyGuid: string;
  documentId: string;
}

export function getByIdAsync$Plain(http: HttpClient, rootUrl: string, params: GetByIdAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<OpenInvitationConfigCto>> {
  const rb = new RequestBuilder(rootUrl, getByIdAsync$Plain.PATH, 'get');
  if (params) {
    rb.path('companyGuid', params.companyGuid, {});
    rb.path('documentId', params.documentId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OpenInvitationConfigCto>;
    })
  );
}

getByIdAsync$Plain.PATH = '/open-invitation-config/company/{companyGuid}/document/{documentId}';
